import script from "./CompanyBranding.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyBranding.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyBranding.vue?vue&type=style&index=0&id=514fd348&lang=css"

const __exports__ = script;

export default __exports__